// True when a client Airbrake notice is entirely Google reCAPTCHA noise
// (obfuscated TypeErrors like reading 'p8' / 'HR' inside recaptcha__*.js).
// airbrake-js historian frames may appear on the stack; they are not ours either.
export function isRecaptchaAirbrakeNoise(notice) {
  const error = notice && notice.errors && notice.errors[0];
  if (!error) return false;

  const backtrace = error.backtrace || [];
  if (backtrace.length === 0) return false;

  let hasRecaptchaFrame = false;
  for (let i = 0; i < backtrace.length; i += 1) {
    const file = backtrace[i] && backtrace[i].file;
    if (!file) return false;

    const isRecaptcha = isRecaptchaScriptUrl(file);
    const isAirbrake = file.indexOf('webpack://airbrakeJs') === 0;
    if (isRecaptcha) {
      hasRecaptchaFrame = true;
    } else if (!isAirbrake) {
      return false;
    }
  }

  return hasRecaptchaFrame;
}

function isRecaptchaScriptUrl(file) {
  return (
    file.indexOf('gstatic.') !== -1 && file.indexOf('/recaptcha/') !== -1
  ) || (
    file.indexOf('google.com/recaptcha/') !== -1
  ) || (
    file.indexOf('recaptcha.net/') !== -1
  );
}
